<template>
<div class="form-page">
    <!-- two selects -->
    <div class="form-selects-year-month__wrap" v-if="showInput">
      <div class="form-select__wrap">
        <select
          :name="work_start_month.name"
          v-model="inputVal[0]"
          v-bind:class="{error: (history[currentStep].isValid === false) && !inputVal[0]}"
          class="form-select">
          <option value="" disabled selected>{{work_start_month.placeholder}}</option>
          <option v-for="(value, name, index) in work_start_month.translate"
         :key="index" :value="value">{{name}}</option>
        </select>
      </div>
      <div class="form-input__wrap" style="width: 40%">
        <input
          :type="work_start_year.type"
          class="form-input"
          v-model="inputVal[1]"
          :name="work_start_year.name"
          v-bind:class="{error: history[currentStep].isValid === false}"
          :placeholder="work_start_year.placeholder"
          required>
        <span class="form-input-floating-label">{{work_start_year.placeholder}}</span>
      </div>
      <div class="form-input__wrap" style="width: 53%; text-align: left">
        <transition name="fade">
          <span class="error-message" v-if="history[currentStep].isValid === false && !inputVal[0]">
            {{work_start_month.error}}
          </span>
        </transition>
      </div>
      <div class="form-input__wrap" style="width: 40%; text-align: left">
        <transition name="fade">
          <span class="error-message" v-if="history[currentStep].isValid === false">
            {{work_start_year.error}}
          </span>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'MonthYear',
  data () {
    return {
      inputVal: ['', ''],
      initValue: false
    }
  },
  computed: {
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep,
      showInput: state => state.showInput,
      config: state => state.config
    }),
    work_start_month () {
      return this.getField('work_start_month')
    },
    work_start_year () {
      return this.getField('work_start_year')
    },
    isValid () {
      const regex = new RegExp(this.work_start_year.reg)
      const isMonth = this.inputVal[0].length > 0
      const isYear = this.inputVal[1] ? regex.test(this.inputVal[1]) : ''
      return [isMonth, isYear]
    }
  },
  mounted () {
    const val = this.history[this.currentStep].value
    const splittedDate = val ? val.split('-') : ['', '', '']
    this.inputVal = [splittedDate[1], splittedDate[2]]
  },
  methods: {
    getField (fieldName) {
      for (const field in this.config.main_fields) {
        if (this.config.main_fields[field].name === fieldName) {
          return this.config.main_fields[field]
        }
      }
    }
  },
  watch: {
    inputVal: function (val) {
      console.log(this.isValid, this.initValue)
      if (!this.initValue) { this.initValue = true; return }
      this.$store.commit('UPDATE_FIELD', { isValid: this.isValid[0] && this.isValid[1], value: `01-${this.inputVal[0]}-${this.inputVal[1]}` })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/fields/MonthYear.vue